module.exports = __webpack_public_path__ + "img/section8_2.52d69d4f.jpg";